<template>
  <div class="content" :id="id">

    <div class="box">
      <div class="tab">
        <div v-for="item in list" :key="item" :class="target === item ? 'tab-box' : 'tab-box'" @click="changeTarget(item)" :style="`${
            target === item
              ? 'background: rgba(203, 180, 134, 1); color: white;'
              : ''
          }`">
          {{ item }}
        </div>
      </div>
      <div class="flag">
        <div v-if="
            imgList.filter((item) => item.type === mapList[target]).length > 0
          ">
          <div v-for="(item, index) in imgList.filter(
              (item) => item.type === mapList[target]
            )" class="flag-box" :key="item.picCode" :ref="'flag-box-' + index" @click="
              pushRouter(`/special-service?${item.url}&name=${item.name}`)
            ">
            <img :src="item.src" />

            <p>{{ item.name }}</p>
          </div>
        </div>
        <div v-else class="qr-pag">
          <img class="ql-img" src="../../../assets/images/no-message.png" />
          <h3 class="df-rich">抱歉!没有找到符合条件的相关内容~~</h3>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
const list = ["亚洲", "非洲", "欧洲", "北美洲", "南美洲", "大洋洲"];
const mapList = {
  亚洲: "TYPE_B9C7FFEFB3EF148",
  北美洲: "TYPE_98E737AE70C789A",
  欧洲: "TYPE_ECA942D6628CB00",
  大洋洲: "TYPE_C47DBB0A7BAA8E0",
  南美洲: "TYPE_110CB771154BBEB",
  非洲: "TYPE_9E2F751AE02CC52",
};
console.log(mapList);
import { getNationalFlag, getNationalPhoto } from "@/api/goaborad.js";
import { getFileDetails } from "@/api/file.js";
export default {
  name: "national-flag",
  props: {
    id: {
      default: "",
      type: String,
    },
    searchKey: {
      default: "",
      type: String,
    },
  },
  data () {
    return {
      list,
      mapList,
      target: "亚洲",
      imgList: [],
      allImg: null,
      spin: false,
    };
  },
  created () {
    this.getList();
  },
  watch: {
    searchKey: function (val) {
      if (val) {
        this.filterImg(val);
      } else {
        this.imgList = this.allImg;
        this.target = "亚洲";
        return;
      }
    },
  },
  methods: {
    changeTarget (item) {
      this.target = item;
    },
    filterImg (val) {
      if (!this.allImg) {
        this.allImg = JSON.parse(JSON.stringify(this.imgList));
      }
      this.imgList = this.allImg.filter((item) => item.name.indexOf(val) > -1);
      console.log(this.imgList);
      const o = Object.entries(this.mapList);
      o.forEach((item) => {
        if (this._.get(item, "1", "") === this._.get(this.imgList, "0.type")) {
          this.changeTarget(this._.get(item, "0", ""));
        }
      });
    },
    getList (type, val) {
      getNationalFlag(type, val).then(async (res) => {
        const list = this._.get(res, "data.records", []);
        const imgs = [];
        for (let item of list) {
          const resP = await getNationalPhoto(item.picCode, item.tenantCode);
          this._.get(resP, "data.contentPicFileDtoList.0.fileCode");
          const imgDetail = await getFileDetails(
            this._.get(resP, "data.appCode"),
            this._.get(resP, "data.tenantCode"),
            [this._.get(resP, "data.contentPicFileDtoList.0.fileCode")]
          );
          imgs.push({
            name: this._.get(resP, "data.picName", ""),
            src: this._.get(Object.values(imgDetail.data), "0.fileHttpUrl"),
            appCode: this._.get(resP, "data.appCode", ""),
            url: this._.get(
              resP,
              "data.contentPicFileDtoList.0.picFileUrl",
              ""
            ),
            type: this._.get(resP, "data.typeCode", ""),
          });
        }
        this.imgList = imgs;
      });
    },
  },
};
</script>
<style lang='less'>
.qr-pag {
  img {
    margin: 0 auto;
  }
  h3 {
    text-align: center;
    padding: 50px;
    color: #aaaaaa;
    font-weight: 500;
    font-family: Microsoft YaHei;
  }
}
</style>
<style scoped lang='less'>
.ql-img {
  display: table-cell;
  text-align: center;
}

.content {
  width: 100%;
  position: relative;
  margin-top: 40px;
  margin-bottom: 47px;
  padding-bottom: 80px;
}
.box {
  width: 1140px;
  /* height: 260px; */
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  background: #fff;
}
.tab {
  font-size: 0px;
}
.tab-box {
  display: inline-block;
  width: 189px;
  height: 66px;
  line-height: 66px;
  background: #dcdcdc;
  cursor: pointer;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999ba3;
  position: relative;
}
.tab-box:not(:last-of-type) {
  margin-right: 1px;
}
.active::after {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  bottom: -18px;
  left: 86px;
  padding: 0;
  border-bottom: 9px solid transparent;
  border-top: 9px solid #cbb486;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  display: block;
  content: "";
  z-index: 10;
}
.flag {
  padding: 0 4px 0 6px;
  margin-top: 42px;
  // font-size: 0px;
  text-align: left;
  min-height: 200px !important;
  //display: flex;
  //flex-wrap: wrap;
  //justify-content: flex-start;
  //flex: 0 0 20%;
}
.has-margin {
  margin-right: 11px;
}
.flag-box {
  width: 180px;
  height: 140px;
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  img {
    width: 180px;
    height: 90px;
    border: 1px solid #e5e5e5;
  }

  p {
    padding: 9px 0 21px 0;
    margin: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #959da9;
    text-align: center;
  }
}
.flag-box:nth-child(6n) {
  margin-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/goaboard/siderContent-05.vue